import { BusCheckin, BusStudentCheckin, Staff } from '@/plugins/api'
import { get } from 'lodash'
import moment from 'moment'
import { Teacher } from '../../../plugins/api'

export default {
  namespaced: true,
  state: {
    loading: false,
    busCheckins: [],
    busCheckin: {},
    busSchedules: [],
    totalItems: 0,
    itemsPerPage: 5,
    busStudentTrackings: [],
    date: moment()
      .startOf('day')
      .toISOString()
  },
  actions: {
    async fetchBusTracking({ state, commit }, params) {
      state.loading = true
      let countParams = { ...params, bus_null: false }
      const [totalItems, busCheckins] = await Promise.all([BusCheckin.count(countParams), BusCheckin.search(params)])
      const driverPromises = busCheckins.map(async item => {
        if (get(item, 'bus.driver')) return Teacher.fetchOne(item.bus.driver)
      })
      const drivers = await Promise.all(driverPromises)
      busCheckins.forEach((item, index) => {
        item.driver = drivers[index]
      })
      commit('changeState', { busCheckins: busCheckins, totalItems: totalItems })
      state.loading = false
    },
    async findOne({ state, commit }, id) {
      state.loading = true
      const busCheckin = await BusCheckin.fetchOne(id)
      commit('changeState', { busCheckin: busCheckin })
      state.loading = false
    },
    async getBusSchedule({ commit }) {
      moment.locale('en')
      let dayOfWeek = moment()
        .format('dddd')
        .toLowerCase()
      const busSchedules = await BusCheckin.getBusSchedule({ dayOfWeek: dayOfWeek })
      busSchedules.map(busSchedule => {
        if (busSchedule.periodTime === 'AM') {
          busSchedule.direction === 'in'
            ? (busSchedule.name = 'Đón học sinh buổi sáng')
            : (busSchedule.name = 'Trả học sinh buổi trưa')
        } else {
          busSchedule.direction === 'in'
            ? (busSchedule.name = 'Đón học sinh buổi chiều')
            : (busSchedule.name = 'Trả học sinh buổi chiều')
        }
      })
      commit('changeState', { busSchedules: busSchedules })
    },
    async getStudentAttendanceInBus({ commit }, query) {
      const attendanceStudents = await BusStudentCheckin.getBusAttendanceStudents(query)
      commit('changeState', { attendanceStudentInBusParams: query, attendanceStudents })
    },
    async getBusStudentTracking({ state, commit }, params) {
      state.loading = true
      const busStudentTrackings = await BusCheckin.getBusStudentTrackings(params)
      commit('changeState', { busStudentTrackings: busStudentTrackings })
      state.loading = false
    },
    setDate({ commit }, date) {
      commit('changeState', { date })
    }
  },
  mutations: {
    setItemPerPage(state, payload) {
      state.itemsPerPage = payload
    },
    resetData(state) {
      state.busCheckins = []
      state.busStudentTrackings = []
    }
  },
  getters: {
    busCheckins: state => {
      return state.busCheckins
    },
    busStudentTrackings: state => state.busStudentTrackings,
    busCheckin: state => state.busCheckin,
    loading: state => state.loading
  }
}
